import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { assertNexusSchedulingMutationAllowed } from './assert-nexus-scheduling-access.js';
import { runRoutePlanning, writeResultToOTRS } from '../server/index.js';

export const testSchedulingByTicketIds = registerMutation({
  operationName: 'testSchedulingByTicketIds',
  type: () => Int,
  resolve: (ticketIDs: string[], writeToOTRS: boolean) => async () => {
    await assertNexusSchedulingMutationAllowed();
    if (!ticketIDs?.length) throw new Error('No ticket IDs provided');
    const result = await runRoutePlanning(writeToOTRS ? 'manual-run' : 'manual-dry-run', ticketIDs);
    if (!result) return 0;
    if (writeToOTRS) await writeResultToOTRS(result);
    return result.routes?.length ?? 0;
  },
  params: [
    { name: 'ticketIDs', type: () => [String] },
    { name: 'writeToOTRS', type: () => Boolean },
  ],
});
